import { ITncRepository } from '../../ports/ITncRepository';
import { TncUpdatePayload } from '../entities/TncUpdatePayload';

export class UpdateTncDetailsUseCase {
  constructor(private readonly tncRepository: ITncRepository) {}

  async execute(caseId: string, payload: TncUpdatePayload): Promise<void> {
    return this.tncRepository.updateTncDetails(caseId, payload);
  }
}
